import * as React from "react";
import Svg, { Path } from "react-native-svg";
function UpBlackArrow(props) {
    return (React.createElement(Svg, { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M12 8.923c.1 0 .192.017.275.05a.762.762 0 01.25.175l4.95 4.95c.133.134.196.313.188.538a.769.769 0 01-.213.537c-.167.167-.346.238-.537.213a.94.94 0 01-.513-.238l-4.4-4.4-4.4 4.4a.816.816 0 01-.537.225.591.591 0 01-.538-.225.55.55 0 01-.212-.525.974.974 0 01.237-.55l4.925-4.925a.762.762 0 01.25-.175.734.734 0 01.275-.05z", fill: "#1D2939" })));
}
export default UpBlackArrow;
